<template>
  <div class="countdown">
    <div class="countdown-digit">{{ minutes | two_digits }}:</div>
    <div class="countdown-digit">{{ seconds | two_digits }}</div>
  </div>
</template>

<script>
export default {
  name: 'Countdown',

  props: {
    // eslint-disable-next-line vue/require-default-prop
    date: {
      type: [String, Date]
    }
  },

  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000)
    };
  },

  computed: {
    dateInMilliseconds() {
      return Math.trunc(new Date(this.date).getTime() / 1000);
    },

    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },

    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    }
  },

  created() {
    const interval = setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000);

      if (this.now === this.dateInMilliseconds) {
        this.$emit('finish');
        clearInterval(interval);
      }
    }, 1000);

    this.$once('hook:beforeDestroy', () => {
      clearInterval(interval);
    });
  }
};
</script>

<style lang="less">
.countdown {
  display: flex;
  align-items: center;
  font-weight: 800;
  font-size: 25px;
  color: #86909b;
  line-height: 30px;

  &-digit {
    width: 35px;

    &:not(:last-of-type) {
      margin-right: 8px;
    }
  }
}
</style>
